import CAGlobalUsersModel from '@/models/dashboard/caglobalusersmodel';
import { CAItemLevelModel } from '@/models/dashboard/caItemLevelModel';
import CAReportZModel from '@/models/dashboard/careportzmodel';
import CASummaryPaymentsModel from '@/models/dashboard/casummarypaymentsmodel';
import CASummarySalesModel from '@/models/dashboard/casummarysalesmodel';
import CurrentModel from '@/models/dashboard/currentmodel';
import GuestCountModel from '@/models/dashboard/guestcountmodel';
import { PointGlobalUsersModel } from '@/models/dashboard/pointglobalusersmodel';
import SalesDetailsModel from '@/models/dashboard/salesdetailsmodel';
import Cached from '@/plugins/cached';
import moment from 'moment/moment';
import BaseProvider from "./baseprovider";

export default class DashProvider extends BaseProvider {
    private static longTTL = 1000 * 60 * 30;

    private async getDash<T>(report: string, storeIds: number[], fromDate: Date, toDate: Date, ctor?: new (data: any) => T): Promise<T[]> {
        const currentDate: Date = moment().startOf('day').toDate();
        const fromString: string = moment(fromDate).format("yyyy-MM-DD");
        const toString: string = moment(toDate).format("yyyy-MM-DD");

        const response = await Promise.all([
            Cached.request(
                'GET',
                `dash/${report}/${fromString}/${toString}`,
                { storeIds }, undefined,
                2,
                false,
                toDate < currentDate ? { ttl: DashProvider.longTTL } : true),
            new Promise((resolve) => setTimeout(resolve, 2000))
        ]);

        const r = this.received(response[0], d => ctor ? new ctor(d) : d);
        console.log (report, r);
        return r;
    }

    public getCAReportZ = (storeIds: number[], fromDate: Date, toDate: Date): Promise<CAReportZModel[]> =>
        this.getDash<CAReportZModel>('CAReportZ', storeIds, fromDate, toDate, CAReportZModel);

    public getCASummaryPayments = (storeIds: number[], fromDate: Date, toDate: Date): Promise<CASummaryPaymentsModel[]> =>
        this.getDash<CASummaryPaymentsModel>('CASummaryPayments', storeIds, fromDate, toDate, CASummaryPaymentsModel);

    public getCASummarySales = async (storeIds: number[], fromDate: Date, toDate: Date): Promise<CASummarySalesModel[]> => {
        const requests: any = [];

        storeIds.forEach((storeId: number) => requests.push(this.getDash<CASummarySalesModel>('CASummarySales', [storeId], fromDate, toDate, CASummarySalesModel)))

        const results = await Promise.all(requests)

        return results.filter(r => r).flat();
    }

    public getCurrent = (storeIds: number[], fromDate: Date, toDate: Date): Promise<CurrentModel[]> =>
        this.getDash<CurrentModel>('Current', storeIds, fromDate, toDate, CurrentModel);

    public getGuestCount = async (storeIds: number[], fromDate: Date, toDate: Date): Promise<GuestCountModel[]> => {
        const requests: any = [];

        storeIds.forEach((storeId: number) => requests.push(this.getDash<GuestCountModel>('GuestCount', [storeId], fromDate, toDate, GuestCountModel)));

        const results = await Promise.all(requests)

        return results.filter(r => r).flat();
    }

    public getCAGlobalUsers = (storeIds: number[], fromDate: Date, toDate: Date): Promise<CAGlobalUsersModel[]> =>
        this.getDash<CAGlobalUsersModel>('CAGlobalUsers', storeIds, fromDate, toDate, CAGlobalUsersModel);

    public getPointGlobalUsers = (storeIds: number[], fromDate: Date, toDate: Date): Promise<PointGlobalUsersModel[]> =>
        this.getDash<PointGlobalUsersModel>('PointGlobalUsers', storeIds, fromDate, toDate);

    public getSalesDetails = (storeIds: number[], fromDate: Date, toDate: Date): Promise<SalesDetailsModel[]> =>
        this.getDash<SalesDetailsModel>('SalesDetails', storeIds, fromDate, toDate, SalesDetailsModel);

    public getCAItemLevels = (storeIds: number[], fromDate: Date, toDate: Date): Promise<CAItemLevelModel[]> =>
        this.getDash<CAItemLevelModel>('CAItemLevels', storeIds, fromDate, toDate);
}